import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.billToSelectorGridItem = {
    width: 12,
    css: css`
        > div[class^="FormFieldStyle"] {
            > div[class^="FormInputWrapper"] {
                > div[class^="OverflowWrapper"] {
                    span[data-test-selector^="changeCustomerBillToSelector-selectedText"] {
                        padding-right: 40px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.shipToSelectorGridItem = {
    width: 12,
    css: css`
        > div[class^="FormFieldStyle"] {
            > div[class^="FormInputWrapper"] {
                > div[class^="OverflowWrapper"] {
                    span[data-test-selector^="changeCustomerShipToSelector-selectedText"] {
                        padding-right: 40px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.fulfillmentMethodSelectorGridItem = {
    width: 12,
    css: css`
        padding: 10px 15px 0;
        > div[class^="GridWrapper"] {
            > div[class^="GridOffset"] {
                > div:first-child[class^="GridItemStyle"] {
                    padding: 0 15px;
                }
                > div:last-child[class^="GridItemStyle"] {
                    padding: 5px;
                }
            }
        }
    `,
};
